/**
 PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA

 *  Copyright © 2017 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';

export default class Modal extends React.Component {
  static propTypes = {
    modalIsOpen: PropTypes.bool.isRequired,
    contentLabel: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    children: PropTypes.element,
    animate: PropTypes.bool,
    appElement: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    zIndex: PropTypes.number,
    backGroundColor: PropTypes.string,
    wrapperId: PropTypes.string
  };

  static defaultProps = {
    animate: true,
    appElement: '#root',
    backGroundColor: '#ffffff'
  };

  componentWillMount() {
    const { appElement } = this.props;
    if (appElement === '#root') {
      if (document.querySelector(appElement)) {
        ReactModal.setAppElement(appElement);
      } else {
        ReactModal.setAppElement('body');
      }
    } else {
      ReactModal.setAppElement(appElement);
    }
  }

  render() {
    const modal = (
      <ReactModal
        isOpen={this.props.modalIsOpen}
        onRequestClose={this.props.onClose}
        contentLabel={this.props.contentLabel}
        closeTimeoutMS={this.props.animate ? 300 : 0}
        portalClassName={this.props.animate ? 'ReactModalPortalAnimated' : 'ReactModalPortal'}
        style={{
          overlay: {
            zIndex: this.props.zIndex || 1200
          },
          content: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            border: 'none',
            background: this.props.backGroundColor ? this.props.backGroundColor : '#ffffff',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            outline: 'none',
            padding: 0
          }
        }}
        role="dialog"
        aria={{
          modal: true
        }}
        {...(this.props.wrapperId && { id: this.props.wrapperId })}
      >
        {this.props.children}
      </ReactModal>
    );

    return modal;
  }
}



// WEBPACK FOOTER //
// ./src/js/Modal.jsx